// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HoCd","input":"styles_input__2RYgu"};